<template>
    <!--头部标题栏-->
    <nut-navbar :left-show="false" title="应聘登记">
    </nut-navbar>
    <!--头部标题栏-->

    <!--遮罩层-->
    <nut-overlay v-model:visible="show_overlay" :close-on-click-overlay="false" :z-index="2000"></nut-overlay>
    <!--应聘职位-->
    <nut-cell-group title="应聘职位">
        <nut-form :model-value="psndoc.job" ref="job_ruleForm" class="width100">
            <nut-form-item label="应聘组织" prop="pk_reg_org">
                <input class="nut-input-text" placeholder="应聘组织" @click="() => { pk_reg_org_date.is_show = true }"
                    v-model="psndoc.job.pk_reg_org_name" type="text" />
                <nut-picker v-model:visible="pk_reg_org_date.is_show" :columns="pk_reg_org_date.List" title="应聘组织"
                    @confirm="pk_reg_orgConfirm">
                </nut-picker>
            </nut-form-item>

            <nut-form-item label="应聘职位" prop="pk_reg_job" required :rules="[{ required: true, message: '请选择应聘职位' }]">
                <input class="nut-input-text" placeholder="应聘职位" @click="() => { pk_reg_job_date.is_show = true }"
                    v-model="psndoc.job.pk_reg_job_name" type="text" />
                <nut-picker v-model:visible="pk_reg_job_date.is_show" :columns="pk_reg_job_date.List" title="应聘职位"
                    @confirm="pk_reg_jobConfirm">
                </nut-picker>
            </nut-form-item>
        </nut-form>
    </nut-cell-group>
    <h2>基本信息</h2>
    <nut-form :model-value="psndoc" ref="base_ruleForm">
        <nut-form-item label="公司">
            <input class="nut-input-text" placeholder="公司" v-model="psndoc.pk_org_name" readonly type="text" />
        </nut-form-item>
        <nut-form-item label="信息来源" prop="glbdef21" required :rules="[{ required: true, message: '请填信息来源' }]">
            <input class="nut-input-text" placeholder="信息来源" @click="() => { src_fromdata.is_show = true; }" readonly
                v-model="psndoc.glbdef21" type="text"/>
            <nut-picker v-model:visible="src_fromdata.is_show" :columns="src_fromdata.List" title="信息来源"
                @confirm="srcfromConfirm">
            </nut-picker>
        </nut-form-item>
        <nut-form-item label="亲属是否在职">
            <nut-switch v-model="psndoc.glbdef22" active-text="是" inactive-text="否"></nut-switch>
        </nut-form-item>
        <nut-form-item label="亲属姓名/部门" v-show="psndoc.glbdef22">
            <input class="nut-input-text" placeholder="亲属姓名/部门" v-model="psndoc.glbdef23" type="text" />
        </nut-form-item>
        <nut-form-item label="目前月薪" prop="salarynow" required :rules="[{ required: true, message: '请填目前月薪' }]">
            <nut-input class="nut-input-text" placeholder="目前月薪" v-model="psndoc.salarynow" type="digit" />
        </nut-form-item>
        <nut-form-item label="期望月薪" prop="expect_wage" required :rules="[{ required: true, message: '请填期望月薪' }]">
            <nut-input class="nut-input-text" placeholder="期望月薪" v-model="psndoc.expect_wage" type="digit" />
        </nut-form-item>
        <nut-form-item label="姓名" prop="name" required :rules="[{ required: true, message: '请填写姓名' },{ validator: (value) => !value || value.trim().length > 0, message: '姓名不能为空或仅包含空格' } ]">
            <input class="nut-input-text" placeholder="请输入姓名" v-model="psndoc.name" type="text"
                @input="generatePinyin" />
        </nut-form-item>
        <nut-form-item label="姓名拼音" prop="glbdef37">
            <input class="nut-input-text" placeholder="" v-model="psndoc.glbdef37" type="text" disabled />
        </nut-form-item>
        <nut-form-item label="证件类型">
            <input class="nut-input-text" @click="() => { idtype_date.is_show = true }" v-model="psndoc.idtype_name"
                readonly placeholder="证件类型" type="text" />
            <nut-picker v-model:visible="idtype_date.is_show" :columns="idtype_date.IdTypeList" title="证件类型"
                @confirm="idtypeConfirm"> </nut-picker>
        </nut-form-item>
        <nut-form-item label="证件号码" prop="id_card" required
            :rules="[{ required: true, message: '请填写证件号码' }, { regex: /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, message: '证件号码格式错误' }]">
            <input class="nut-input-text" placeholder="证件号码" v-model="psndoc.id_card" type="text" @blur="formatter" />
        </nut-form-item>
        <nut-form-item label="性别">
            <nut-radiogroup direction="horizontal" v-model="psndoc.sex">
                <nut-radio label="1">男</nut-radio>
                <nut-radio label="2">女</nut-radio>
            </nut-radiogroup>
        </nut-form-item>
        <nut-form-item label="出生日期" prop="birthdate" readonly required
            :rules="[{ required: true, message: '请填写出生日期' }]">
            <input class="nut-input-text" @click="() => { birthdate_data.is_show = true }" v-model="psndoc.birthdate"
                readonly placeholder="出生日期" type="text" />
            <!-- 2022-8-4 出生日期由身份证号自动带出之后改成不能修改状态
                <nut-datepicker
                v-model="psndoc.birthdate"
                title="出生日期"
                type="date"
                :min-date="birthdate_data.minDate"
                :max-date="birthdate_data.maxDate"
                @confirm="birthdateConfirm"
                v-model:visible="birthdate_data.is_show" 
            ></nut-datepicker>  -->
        </nut-form-item>
        <nut-form-item label="年龄" prop="glbdef30" required :rules="[{ required: true, message: '请填写年龄' }]">
            <input class="nut-input-text" placeholder="请输入年龄" v-model="psndoc.glbdef30" type="number" readonly />
        </nut-form-item>
        <nut-form-item label="民族">
            <input class="nut-input-text" @click="() => { nationality_date.is_show = true }"
                v-model="psndoc.nationality_name" readonly placeholder="民族" type="text" disabled />
            <nut-picker v-model:visible="nationality_date.is_show" :columns="nationality_date.List" title="民族"
                @confirm="nationalityConfirm">
            </nut-picker>
        </nut-form-item>
        <nut-form-item label="身高" prop="glbdef2" required :rules="[{ required: true, message: '请填写身高' }]">
            <nut-input class="nut-input-text" placeholder="身高(cm)，请输入整数" v-model="psndoc.glbdef2" type="digit" />
        </nut-form-item>
        <nut-form-item label="体重" prop="glbdef3" required :rules="[{ required: true, message: '请填写体重' }]">
            <nut-input class="nut-input-text" placeholder="体重(kg)，请输入整数" v-model="psndoc.glbdef3" type="digit" />
        </nut-form-item>
        <nut-form-item label="血型" prop="bloodtype_name" required :rules="[{ required: true, message: '请填写血型' }]">
            <input class="nut-input-text" @click="() => { bloodtype_date.is_show = true }"
                v-model="psndoc.bloodtype_name" readonly placeholder="血型" type="text"  />
            <nut-picker v-model:visible="bloodtype_date.is_show" :columns="bloodtype_date.List" title="血型"
                @confirm="bloodtypeConfirm">
            </nut-picker>
        </nut-form-item>
        <nut-form-item label="手机号码" prop="mobile" required
            :rules="[{ required: true, message: '请填写手机号码' }, { regex: /^1[3-9]\d{9}$/, message: '手机号码格式错误' }]">
            <input class="nut-input-text" placeholder="手机号码" v-model="psndoc.mobile" type="tel" />
        </nut-form-item>
        <nut-form-item label="微信号" prop="glbdef5" required :rules="[{ required: true, message: '请填微信号' }]">
            <input class="nut-input-text" placeholder="微信号" v-model="psndoc.glbdef5" type="text" />
        </nut-form-item>
        <nut-form-item label="户籍地址" prop="glbdef24" required :rules="[{ required: true, message: '请填写户籍地址' }]">
            <input class="nut-input-text" placeholder="需详细到村镇、小区" v-model="psndoc.glbdef24" type="text" />
        </nut-form-item>
        <nut-form-item label="家庭地址" prop="glbdef34" required :rules="[{ required: true, message: '请填写家庭地址' }]">
            <input class="nut-input-text" placeholder="需详细到村镇、小区" v-model="psndoc.glbdef34" type="text" />
        </nut-form-item>
        <nut-form-item label="健康状况">
            <nut-radiogroup direction="horizontal" v-model="psndoc.health">
                <nut-radio label="@@@@Z710000000005L26">健康/良好</nut-radio>
                <nut-radio label="@@@@Z710000000005L27">一般或较弱</nut-radio>
            </nut-radiogroup>
        </nut-form-item>
        <nut-form-item label="婚姻状况" prop="marital_name" required :rules="[{ required: true, message: '请填写婚姻状况' }]">
            <input class="nut-input-text" placeholder="婚姻状况" @click="() => { marital_date.is_show = true }"
                v-model="psndoc.marital_name" type="text" />
            <nut-picker v-model:visible="marital_date.is_show" :columns="marital_date.List" title="婚姻状况"
                @confirm="maritalConfirm">
            </nut-picker>
        </nut-form-item>

        <!-- <nut-form-item label="籍贯">
          <input class="nut-input-text" placeholder="籍贯" v-model="psndoc.nativeplace" type="text" />
      </nut-form-item> -->

        <nut-form-item label="政治面貌" prop="polity_name" required :rules="[{ required: true, message: '请填写政治面貌' }]">
            <input class="nut-input-text" placeholder="政治面貌" @click="() => { polity_date.is_show = true }"
                v-model="psndoc.polity_name" type="text" />
            <nut-picker v-model:visible="polity_date.is_show" :columns="polity_date.List" title="政治面貌"
                @confirm="polityConfirm">
            </nut-picker>
        </nut-form-item>

        <nut-form-item label="学历" prop="edu" required :rules="[{ required: true, message: '请填写学历' }]">
            <input class="nut-input-text" @click="() => { education_data2.is_show = true }" v-model="psndoc.edu_name"
                readonly placeholder="学历" type="text" />
            <nut-picker v-model:visible="education_data2.is_show" :columns="education_data2.List" title="学历"
                @confirm="psnEduConfirm"> </nut-picker>
        </nut-form-item>

        <!-- <nut-form-item label="学位">
          <input class="nut-input-text" placeholder="学位" type="text" />
      </nut-form-item>

      <nut-form-item label="专业">
          <input class="nut-input-text" placeholder="专业" type="text" />
      </nut-form-item>

      <nut-form-item label="学校">
          <input class="nut-input-text" placeholder="学校" type="text" />
      </nut-form-item> -->

        <!-- <nut-form-item label="外语语种">
            <input class="nut-input-text" placeholder="外语语种" @click="() => { glbdef10_date.is_show = true }"
                v-model="psndoc.glbdef10_name" type="text" />
            <nut-picker v-model:visible="glbdef10_date.is_show" :columns="glbdef10_date.List" title="外语语种"
                @confirm="glbdef10Confirm">
            </nut-picker>
        </nut-form-item>

        <nut-form-item label="外语等级">
            <input class="nut-input-text" placeholder="外语等级" @click="() => { glbdef11_date.is_show = true }"
                v-model="psndoc.glbdef11_name" type="text" />
            <nut-picker v-model:visible="glbdef11_date.is_show" :columns="glbdef11_date.List" title="外语等级"
                @confirm="glbdef11Confirm">
            </nut-picker>
        </nut-form-item> -->
        <nut-form-item label="计算机水平" prop="computerlevel" required :rules="[{ required: true, message: '请填写计算机水平' }]">
            <input class="nut-input-text" placeholder="计算机水平" @click="() => { computerlevelSelct.is_show = true }"
                v-model="psndoc.computerlevel" type="text" />
            <nut-picker v-model:visible="computerlevelSelct.is_show" :columns="computerlevelSelct.List" title="计算机水平"
                @confirm="computerLevelConfirm">
            </nut-picker>
        </nut-form-item>
        <nut-form-item label="专业技能或证书" prop="glbdef12" required :rules="[{ required: true, message: '请填写专业技能或证书' }]">
            <input class="nut-input-text" v-model="psndoc.glbdef12" placeholder="专业技能或证书，请尽量填写全面" type="text" />
        </nut-form-item>

        <nut-form-item label="是否入职过仁丰" prop="glbdef15" required :rules="[{ required: true, message: '请选择是否入职过仁丰' }]">
            <!-- <nut-switch v-model="psndoc.glbdef15" active-text="是" inactive-text="否"></nut-switch> -->
            <nut-radiogroup  direction="horizontal" v-model="psndoc.glbdef15">
                <nut-radio :label="true">是</nut-radio>
                <nut-radio :label="false">否</nut-radio>
            </nut-radiogroup>
        </nut-form-item>

        <nut-form-item label="是否退役军人" prop="glbdef25" required :rules="[{ required: true, message: '请选择是否退役军人' }]">
            <!-- <nut-switch v-model="psndoc.glbdef25" active-text="是" inactive-text="否"></nut-switch> -->
            <nut-radiogroup  direction="horizontal" v-model="psndoc.glbdef25">
                <nut-radio :label="true">是</nut-radio>
                <nut-radio :label="false">否</nut-radio>
            </nut-radiogroup>
        </nut-form-item>

        <nut-form-item label="是否触犯法规" prop="glbdef26" required :rules="[{ required: true, message: '请选择是否触犯法律' }]">
            <!-- <nut-switch v-model="psndoc.glbdef26" active-text="是" inactive-text="否"></nut-switch> -->
            <nut-radiogroup  direction="horizontal" v-model="psndoc.glbdef26">
                <nut-radio :label="true">是</nut-radio>
                <nut-radio :label="false">否</nut-radio>
            </nut-radiogroup>
        </nut-form-item>

        <nut-form-item label="触犯原因" v-show="psndoc.glbdef26">
            <input class="nut-input-text" placeholder="触犯原因" v-model="psndoc.crime" type="text" />
        </nut-form-item>

        <nut-form-item label="身体是否受过伤" prop="glbdef36" required :rules="[{ required: true, message: '请选择身体是否受过伤' }]">
            <!-- <nut-switch v-model="psndoc.glbdef36" active-text="是" inactive-text="否"></nut-switch> -->
            <nut-radiogroup  direction="horizontal" v-model="psndoc.glbdef36">
                <nut-radio :label="true">是</nut-radio>
                <nut-radio :label="false">否</nut-radio>
            </nut-radiogroup>
        </nut-form-item>

        <!-- <nut-form-item label="联系人电话" prop="rm_psndoc1.glbdef2" required :rules="[{ required: true, message: '请填写联系人电话' }]">
          <input class="nut-input-text" v-model="psndoc.rm_psndoc1.glbdef2" placeholder="联系人电话" type="number" />
      </nut-form-item> -->
    </nut-form>

    <!--应聘职位-->
    <!-- <nut-cell-group title="应聘职位">
        <nut-form :model-value="psndoc.job" ref="job_ruleForm" class="width100">
            <nut-form-item label="应聘组织" prop="pk_reg_org">
                <input class="nut-input-text" placeholder="应聘组织" @click="() => { pk_reg_org_date.is_show = true }"
                    v-model="psndoc.job.pk_reg_org_name" type="text" />
                <nut-picker v-model:visible="pk_reg_org_date.is_show" :columns="pk_reg_org_date.List" title="应聘组织"
                    @confirm="pk_reg_orgConfirm">
                </nut-picker>
            </nut-form-item>

            <nut-form-item label="应聘职位" prop="pk_reg_job" required :rules="[{ required: true, message: '请选择应聘职位' }]">
                <input class="nut-input-text" placeholder="应聘职位" @click="() => { pk_reg_job_date.is_show = true }"
                    v-model="psndoc.job.pk_reg_job_name" type="text" />
                <nut-picker v-model:visible="pk_reg_job_date.is_show" :columns="pk_reg_job_date.List" title="应聘职位"
                    @confirm="pk_reg_jobConfirm">
                </nut-picker>
            </nut-form-item>
        </nut-form>
    </nut-cell-group> -->

    <!--教育信息-->
    <nut-cell-group title="教育信息">
        <nut-cell round-radius="0" v-for="(edu, index) in psndoc.edus" :key="index">
            <nut-form class="width100" ref="edu_ruleForm" :key="index">
                <nut-form-item label="学校" prop="school" required :rules="[{ required: true, message: '请填写学校信息' }]">
                    <input class="nut-input-text" placeholder="学校" v-model="edu.school" type="text" />
                </nut-form-item>
                <nut-form-item label="入学日期" prop="begindate" required :rules="[{ required: true, message: '请填写入学日期' }]">
                    <input class="nut-input-text"
                        @click="() => { edu_begindate_sel_index = index; begindate_data.is_show = true; }"
                        v-model="edu.begindate" readonly placeholder="入学日期" type="text" />
                    <nut-datepicker title="入学日期" type="date" :min-date="begindate_data.minDate"
                        :max-date="begindate_data.maxDate" @confirm="begindataConfirm"
                        v-model:visible="begindate_data.is_show"></nut-datepicker>
                </nut-form-item>
                <nut-form-item label="毕业日期" prop="enddate" required :rules="[{ required: true, message: '请填写毕业日期' }]">
                    <input class="nut-input-text"
                        @click="() => { edu_enddate_sel_index = index; enddate_data.is_show = true; }"
                        v-model="edu.enddate" readonly placeholder="毕业日期" type="text" />
                    <nut-datepicker title="毕业日期" type="date" :min-date="enddate_data.minDate"
                        :max-date="enddate_data.maxDate" @confirm="enddateConfirm"
                        v-model:visible="enddate_data.is_show"></nut-datepicker>
                </nut-form-item>
                <nut-form-item label="专业" required>
                    <input class="nut-input-text" placeholder="专业" v-model="edu.major" type="text" />
                </nut-form-item>
                <nut-form-item label="学习方式" required>
                    <input class="nut-input-text"
                        @click="() => { studymode_sel_index = index; studymode_data.is_show = true }"
                        v-model="edu.studymode_name" placeholder="学习方式" type="text" />
                    <nut-picker v-model:visible="studymode_data.is_show" :columns="studymode_data.List" title="学习方式"
                        @confirm="studymodeConfirm"> </nut-picker>
                </nut-form-item>
                <nut-form-item label="学历" required>
                    <input class="nut-input-text"
                        @click="() => { edu_education_sel_index = index; education_data.is_show = true }"
                        v-model="edu.education_name" readonly placeholder="学历" type="text" />
                    <nut-picker v-model:visible="education_data.is_show" :columns="education_data.List" title="学历"
                        @confirm="educationConfirm"> </nut-picker>
                </nut-form-item>
                <nut-form-item label="是否最高学历">
                    <nut-switch v-model="edu.lastflag" @change="educationChange(index)" active-text="是"
                        inactive-text="否"></nut-switch>
                </nut-form-item>
                <nut-form-item v-show="index > 1">
                    <nut-button size="small" @click="delEdu(index)">删除</nut-button>
                </nut-form-item>
            </nut-form>
        </nut-cell>
        <nut-cell round-radius="0" v-show="psndoc.edus.length < 3">
            <nut-button block shape="square" type="primary" @click="addEdu">添加学历</nut-button>
        </nut-cell>
    </nut-cell-group>

    <!---工作信息-->
    <nut-cell-group title="工作信息">
        <nut-cell round-radius="0" v-for="(work, index) in psndoc.works" :key="index">
            <nut-form class="width100" ref="work_ruleForm">
                <nut-form-item label="开始日期" prop="begindate" required :rules="[{ required: true, message: '请填写开始日期' }]">
                    <input class="nut-input-text"
                        @click="() => { work_begindate_sel_index = index; work_begindate_data.is_show = true }"
                        v-model="work.begindate" readonly placeholder="开始日期" type="text" />
                    <nut-datepicker title="开始日期" type="date" :min-date="work_begindate_data.minDate"
                        :max-date="work_begindate_data.maxDate" @confirm="work_begindateConfirm"
                        v-model:visible="work_begindate_data.is_show"></nut-datepicker>
                </nut-form-item>
                <nut-form-item label="结束日期" prop="enddate" required :rules="[{ required: true, message: '请填写结束日期' }]">
                    <input class="nut-input-text"
                        @click="() => { work_enddate_sel_index = index; work_enddate_data.is_show = true }"
                        v-model="work.enddate" readonly placeholder="结束日期" type="text" />
                    <nut-datepicker title="结束日期" type="date" :min-date="work_enddate_data.minDate"
                        :max-date="work_enddate_data.maxDate" @confirm="work_enddateConfirm"
                        v-model:visible="work_enddate_data.is_show"></nut-datepicker>
                </nut-form-item>
                <nut-form-item label="工作单位" prop="workcorp" required :rules="[{ required: true, message: '请填写工作单位' }]">
                    <input class="nut-input-text" placeholder="工作单位" v-model="work.workcorp" type="text" />
                </nut-form-item>
                <nut-form-item label="担任职务" required>
                    <input class="nut-input-text" placeholder="担任职务" v-model="work.workjob" type="text" />
                </nut-form-item>
                <nut-form-item label="主要职责">
                    <input class="nut-input-text" placeholder="主要职责" v-model="work.workduty" type="text" />
                </nut-form-item>
                <nut-form-item label="直接上级" required>
                    <input class="nut-input-text" placeholder="直接上级" v-model="work.certifier" type="text" />
                </nut-form-item>
                <nut-form-item label="直接上级联系方式" required>
                    <input class="nut-input-text" placeholder="直接上级联系方式" v-model="work.certiphone" type="tel" />
                </nut-form-item>
                <nut-form-item label="离职原因" required>
                    <input class="nut-input-text" placeholder="离职原因" v-model="work.dismismatter" type="text" />
                </nut-form-item>
                <nut-form-item v-show="index > 2">
                    <nut-button size="small" @click="delWork(index)">删除</nut-button>
                </nut-form-item>
            </nut-form>
        </nut-cell>
        <nut-cell round-radius="0" v-show="psndoc.works.length < 5">
            <nut-button block shape="square" type="primary" @click="addWork">添加工作</nut-button>
        </nut-cell>
    </nut-cell-group>

    <!--家庭信息-->
    <nut-cell-group title="家庭信息">
        <nut-cell round-radius="0" v-for="(person, index) in psndoc.persons" :key="index">
            <nut-form :model-value="person" ref="psn_ruleForm" class="width100">
                <nut-form-item label="姓名" prop="mem_name" required :rules="[{ required: true, message: '请填写姓名' }]">
                    <input class="nut-input-text" placeholder="姓名" v-model="person.mem_name" type="text" />
                </nut-form-item>
                <nut-form-item label="与本人关系" prop="mem_relation" required
                    :rules="[{ required: true, message: '请填写关系' }]">
                    <input class="nut-input-text"
                        @click="() => { psn_relation_sel_index = index; psn_data.is_show = true }"
                        v-model="person.mem_relation_name" readonly placeholder="与本人关系" type="text" />
                    <nut-picker v-model:visible="psn_data.is_show" :columns="psn_data.List" title="与本人关系"
                        @confirm="psnConfirm"> </nut-picker>
                </nut-form-item>
                <nut-form-item label="生日" prop="mem_birthday" required :rules="[{ required: true, message: '请填写生日' }]">
                    <input class="nut-input-text"
                        @click="() => { mem_birthday_sel_index = index; mem_birthday_data.is_show = true }"
                        v-model="person.mem_birthday" readonly placeholder="生日" type="text" />
                    <nut-datepicker title="生日" type="date" :min-date="mem_birthday_data.minDate"
                        :max-date="mem_birthday_data.maxDate" @confirm="mem_birthdayConfirm"
                        v-model:visible="mem_birthday_data.is_show"></nut-datepicker>
                </nut-form-item>
                <!-- <nut-form-item label="年龄" prop="glbdef3" required :rules="[{ required: true, message: '请填写年龄' }]">
                    <input class="nut-input-text" placeholder="请输入年龄" v-model="person.glbdef3" type="digit" />
                </nut-form-item> -->
                <nut-form-item label="工作单位及职务" prop="mem_corp" required
                    :rules="[{ required: true, message: '请填写工作单位及职务' }]">
                    <input class="nut-input-text" placeholder="工作单位及职务" v-model="person.mem_corp" type="text" />
                </nut-form-item>
                <!-- <nut-form-item label="职务" prop="mem_job">
                    <input class="nut-input-text" placeholder="职务" v-model="person.mem_job" type="text" />
                </nut-form-item> -->
                <nut-form-item label="电话" prop="tel" required :rules="[{ required: true, message: '请填写电话' }]">
                    <input class="nut-input-text" placeholder="电话" v-model="person.vrelaphone" type="tel" />
                </nut-form-item>
                <nut-form-item label="紧急联系人">
                    <nut-switch v-model="person.glbdef1" active-text="是" inactive-text="否"></nut-switch>
                </nut-form-item>
                <!-- <nut-form-item v-show="index > 4">
                    <nut-button size="small" @click="delPsn(index)">删除</nut-button>
                </nut-form-item> -->
            </nut-form>
        </nut-cell>
        <!-- <nut-cell round-radius="0">
            <nut-button block shape="square" type="primary" @click="addPsn">添加成员</nut-button>
        </nut-cell> -->
    </nut-cell-group>

    <!--附件信息-->
    <nut-cell-group title="附件信息（上传测评表、身份证、毕业证照片）">
        <nut-cell round-radius="0">
            <nut-uploader auto-upload method="post" v-model:file-list="defaultFileList" :data="fileformData"
                :url="uploadUrl" @success="upSuccess" :before-xhr-upload="beforeUpload" @failure="upError" maximum="5"
                :before-delete="beforeDelete" multiple maximize='5242880' @oversize="onOversize"></nut-uploader>
        </nut-cell>
    </nut-cell-group>

    <!--back top -->
    <nut-backtop el-id="elId3" :distance="200" :bottom="70" style="background-color: green;color: white;">
        <div @click="saveTemp">暂存</div>
    </nut-backtop>
    <nut-backtop></nut-backtop>
    <!--提交-->
    <nut-cell-group title="">
        <nut-cell round-radius="0">
            <nut-button block shape="square" :disabled="submit_disabled" type="danger" @click="submit">提交</nut-button>
        </nut-cell>
    </nut-cell-group>
</template>

<script>
/* eslint-disable */
import { ref, reactive, getCurrentInstance, onMounted, onUnmounted, watch } from 'vue';
import { Notify, Toast } from '@nutui/nutui';
import signMd5Utils from '../../common/signMd5Utils';
import { pinyin } from 'pinyin-pro';
export default {
    name: 'IndexPage',
    setup() {
        const defaultFileList = reactive([])
        //获取全局axios
        const api = getCurrentInstance().appContext.config.globalProperties.$api;
        const qs = getCurrentInstance().appContext.config.globalProperties.$qs;
        const baseUrl = getCurrentInstance().appContext.config.globalProperties.$baseUrl;
        let now = new Date().getTime();
        const uploadHeaders = reactive({
            "X-TIMESTAMP": now,
            "X-SIGN": signMd5Utils.getSign(baseUrl + "/api/psndoc/upload", {
                "X-TIMESTAMP": now
            })
        });
        //员工入职信息modal
        const psndoc = reactive({
            "age": "", //年龄只做显示 不存储
            "birthdate": "",
            "bloodtype": "",//"血型", 
            "bloodtype_name": "",//"血型", 
            "computerlevel": "",//"计算机水平", 
            "crime": "",//"触犯原因"
            "expect_wage": "",//"期望月薪", 
            "edu": "",//"学历pk",
            "edu_name": "",//"学历名称",
            "glbdef2": "",//"身高(cm)", 
            "glbdef3": "",//"体重(kg)", 
            "glbdef5": "",//"微信", 
            "glbdef6": "",//"QQ", 
            "glbdef8": "",//"专业", 
            "glbdef10": "",//"外语语种", 
            "glbdef10_name": "",//"外语语种", 
            "glbdef11": "",//"外语等级", 
            "glbdef11_name": "",//"外语等级", 
            "glbdef12": "",//"职称/执业/职业资格", 
            "glbdef13": "",//"评定时间", 
            "glbdef15": undefined,//"是否军人", 
            "glbdef21": "",//"从何处获知招聘信息", 
            "glbdef22": false,//"是否有亲属、朋友在职", 
            "glbdef23": "",//"姓名/部门", 
            "glbdef24": "",//户籍地址, 
            "glbdef25": undefined,//"是否入职过我公司", 
            "glbdef26": undefined,//"是否曾触犯过国家刑法或其他法律法规", 
            "glbdef30": "",//"年龄", 
            "glbdef34": "",//"家庭地址", 
            "glbdef36": undefined,//"是否受过伤", 
            "glbdef37": "",//"姓名拼音"
            "health": "@@@@Z710000000005L26", //1 健康 2良好
            "id": "",
            "idtype": "1001Z01000000000AI36",//默认选中身份证 
            "idtype_name": "身份证",//默认选中身份证 
            "interest": "",//"兴趣爱好", 
            "marital": "", //1 已婚 2 未婚
            "marital_name": "",
            "mobile": "",//"手机", 
            "name": "",
            "nationality": "@@@@Z710000000005L2S",  //默认选中汉族
            "nationality_name": "汉族", //默认选中汉族
            "nativeplace": "",//"籍贯", 
            "pk_degree": "",//"学位", 
            "pk_org": "0001A110000000002UST",
            "pk_org_name": "山东仁丰特种材料股份有限公司",
            "pk_psndoc": "",//人员PK
            "polity": "",//"政治面貌" @@@@Z710000000005L8Q, 
            "polity_name": "",//"政治面貌名称" 群众, 
            "salarynow": "",//"目前月薪", 
            "sex": "1", //1 男 2 女
            "skill": "",//专业技能或证书,
            "usedname": "",
            // "rm_psndoc1":{
            //     "glbdef1": "",//"紧急联系人", 
            //     "glbdef2": "",//"紧急联系人电话", 
            // },
            //应聘职位
            "job":
            {
                "pk_reg_org": "0001A110000000002UST", //应聘组织
                "pk_reg_org_name": "山东仁丰特种材料股份有限公司", //
                "pk_reg_job": "", //应聘职位
                "pk_reg_job_name": ""// 
            },
            "edus": [
                {
                    "school": "", //学校
                    "begindate": "", //入学日期
                    "enddate": "", //毕业日期
                    "major": "",//"专业 
                    "studymode": "",//学习方式  1001Z710000000016XIZ
                    "studymode_name": "",//学习方式  全日制
                    "education": "",//学历  30
                    "education_name": "",//学历名称  大专
                    "lastflag": "", //是否最高学历
                    "degree": ""//学位
                },
                {
                    "school": "", //学校
                    "begindate": "", //入学日期
                    "enddate": "", //毕业日期
                    "major": "",//"专业 
                    "studymode": "",//学习方式  1001Z710000000016XIZ
                    "studymode_name": "",//学习方式  全日制
                    "education": "",//学历  30
                    "education_name": "",//学历名称  大专
                    "lastflag": "", //是否最高学历
                    "degree": ""//学位
                }
            ],
            "works": [
                {
                    "begindate": "", //入学日期
                    "enddate": "",//毕业日期 
                    "workcorp": "",//工作单位 
                    "workjob": "",//担任职务 
                    "workduty": "",//主要职责 
                    "certifier": "",//证明人 
                    "certiphone": "",//上级联系方式 
                    "dismismatter": ""//证明人电话
                },
                {
                    "begindate": "", //入学日期
                    "enddate": "",//毕业日期 
                    "workcorp": "",//工作单位 
                    "workjob": "",//担任职务 
                    "workduty": "",//主要职责 
                    "certifier": "",//证明人 
                    "certiphone": "",//证明人电话 
                    "dismismatter": ""//证明人电话
                },
                {
                    "begindate": "", //入学日期
                    "enddate": "",//毕业日期 
                    "workcorp": "",//工作单位 
                    "workjob": "",//担任职务 
                    "workduty": "",//主要职责 
                    "certifier": "",//证明人 
                    "certiphone": "",//证明人电话 
                    "dismismatter": ""//证明人电话
                }
            ],
            "persons": [
                {
                    "mem_name": "", //家庭成员姓名
                    "mem_relation": "",//与本人关系  1001Z710000000006O03
                    "mem_relation_name": "",//与本人关系  配偶
                    "workcorp": "",//工作单位 
                    "mem_birthday": "",//出生日期 
                    "mem_corp": "",//工作单位 
                    "mem_job": "",//职务 
                    "vrelaphone": "",//联系电话
                    "glbdef1": true,//是否紧急联系人
                    "glbdef3": ""//年龄
                },
                {
                    "mem_name": "", //家庭成员姓名
                    "mem_relation": "",//与本人关系  1001Z710000000006O03
                    "mem_relation_name": "",//与本人关系  配偶
                    "workcorp": "",//工作单位 
                    "mem_birthday": "",//出生日期 
                    "mem_corp": "",//工作单位 
                    "mem_job": "",//职务 
                    "vrelaphone": "",//联系电话
                    "glbdef1": false,//是否紧急联系人
                    "glbdef3": ""//年龄
                },
                {
                    "mem_name": "", //家庭成员姓名
                    "mem_relation": "",//与本人关系  1001Z710000000006O03
                    "mem_relation_name": "",//与本人关系  配偶
                    "workcorp": "",//工作单位 
                    "mem_birthday": "",//出生日期 
                    "mem_corp": "",//工作单位 
                    "mem_job": "",//职务 
                    "vrelaphone": "",//联系电话
                    "glbdef1": false,//是否紧急联系人
                    "glbdef3": ""//年龄
                },
                {
                    "mem_name": "", //家庭成员姓名
                    "mem_relation": "",//与本人关系  1001Z710000000006O03
                    "mem_relation_name": "",//与本人关系  配偶
                    "workcorp": "",//工作单位 
                    "mem_birthday": "",//出生日期 
                    "mem_corp": "",//工作单位 
                    "mem_job": "",//职务 
                    "vrelaphone": "",//联系电话
                    "glbdef1": false,//是否紧急联系人
                    "glbdef3": ""//年龄
                },
                {
                    "mem_name": "", //家庭成员姓名
                    "mem_relation": "",//与本人关系  1001Z710000000006O03
                    "mem_relation_name": "",//与本人关系  配偶
                    "workcorp": "",//工作单位 
                    "mem_birthday": "",//出生日期 
                    "mem_corp": "",//工作单位 
                    "mem_job": "",//职务 
                    "vrelaphone": "",//联系电话
                    "glbdef1": false,//是否紧急联系人
                    "glbdef3": ""//年龄
                }
            ]
        });

        const generatePinyin = () => {
            if (pinyin) {
                psndoc.glbdef37 = pinyin(psndoc.name, {
                    toneType: 'none', // 无声调
                    type: 'array', // 返回数组
                    separator: '', // 分隔符为空
                }).join('');
            } else {
                console.error('convert is not defined');
            }
        };


        //提交遮罩层
        const show_overlay = ref(false);

        const validate = (item) => {
            console.log(item);
        };
        //基础信息
        const base_ruleForm = ref(null);
        //应聘职位
        const job_ruleForm = ref(null);
        //学历信息
        const edu_ruleForm = ref(null);
        //工作信息
        const work_ruleForm = ref(null);
        //家庭信息
        const psn_ruleForm = ref(null);

        //亲属是否在职const onjob = ref(false);
        //性别 1:男，2:女const sex=ref('1');

        //信息来源
        //智联招聘；boss直聘；人社局直播带岗；微信宣传；抖音宣传；内部人员推荐；其他渠道
        const src_fromdata = reactive({
            is_show: false,
            List: [
                // { text: '58同城', value: '58同城' },
                // { text: '齐鲁人才网', value: '齐鲁人才网' },
                { text: '智联招聘', value: '智联招聘' },
                { text: 'BOSS直聘', value: 'BOSS直聘' },
                { text: '人社局直播带岗', value: '人社局直播带岗' },
                // { text: '前程无忧', value: '前程无忧' },
                // { text: '制纸英才网', value: '制纸英才网' },
                { text: '微信宣传', value: '微信宣传' },
                { text: '抖音宣传', value: '抖音宣传' },
                { text: '招聘会', value: '招聘会' },
                { text: '校园招聘会', value: '校园招聘会' },
                { text: '内部人员推荐', value: '内部人员推荐' },
                { text: '其他渠道', value: '其他渠道' }
            ]
        });

        const srcfromConfirm = ({ selectedValue, selectedOptions }) => {
            console.log(selectedValue);
            console.log(selectedOptions);
            // psndoc.glbdef21 = selectedOptions.map((option) => option.text);
            psndoc.glbdef21 = selectedValue[0];

        }
        /********出生日期********/
        const birthdate_data = reactive({
            is_show: false,
            minDate: new Date(1970, 0, 1),
            maxDate: new Date(2075, 0, 1),
        });
        //出生日期Valueconst birthdate=ref();
        //出生日期选择
        const birthdateConfirm = ({ selectedValue, selectedOptions }) => {
            console.log(selectedValue);
            console.log(selectedOptions);
            psndoc.birthdate = selectedOptions.map((option) => option.text).join('-');
        }
        /********证件类型********/
        const idtype_date = reactive({
            //是否显示
            is_show: false,
            //默认选中
            //selectedValue:'CN01',
            //证件类型list
            IdTypeList: [
                { text: '身份证', value: 'CN01', pk: '1001Z01000000000AI36' },
                { text: '护照', value: 'CN02', pk: '1001Z01000000000CHUJ' },
                { text: '回乡证', value: 'CN03', pk: '1001Z01000000000CHUL' },
                { text: '外国永久居留证', value: 'CN04', pk: '1001Z01000000000CHUP' },
                // { text: '香港居民身份证', value: 'HK01' ,pk:'1001Z01000000000CHUK'},
                // { text: '澳门居民身份证', value: 'M001',pk:'1001Z01000000000CHUN' },
                // { text: '台湾身份证', value: 'TW01' ,pk:'1001Z01000000000CHUM'},
                { text: '台胞证', value: 'TW02', pk: '1001Z01000000000CHUO' }
            ]
        });
        //证件类型Valueconst idtype = ref('身份证');
        //证件类型选择
        const idtypeConfirm = ({ selectedValue, selectedOptions }) => {
            console.log(selectedValue);
            selectedOptions.map(function (option) {
                psndoc.idtype = option.pk;
            });
            //psndoc.idtype=selectedOptions.map((option) => option.pk);//selectedValue;
            psndoc.idtype_name = selectedOptions.map((option) => option.text);
        }

        /**证件号码时间抽取生日及性别*/
        const formatter = (value, event) => {
            //判断是否为身份证
            if (psndoc.idtype === '1001Z01000000000AI36') {
                console.log(psndoc.id_card);
                //生日
                let birthday = psndoc.id_card.substring(6, 10) + "-" + psndoc.id_card.substring(10, 12) + "-" + psndoc.id_card.substring(12, 14);
                psndoc.birthdate = birthday;
                let birthDate = new Date(birthday);
                let currentDate = new Date();
                let age = currentDate.getFullYear() - birthDate.getFullYear();
                if ((currentDate.getMonth() < birthDate.getMonth()) ||
                    (currentDate.getMonth() == birthDate.getMonth() && currentDate.getDate() < birthDate.getDate())) {
                    age--;
                }
                psndoc.glbdef30 = age;
                //性别
                if (parseInt(psndoc.id_card.substr(16, 1)) % 2 === 1) {
                    //return "男"
                    psndoc.sex = "1";
                } else {
                    //return "女"
                    psndoc.sex = "2";
                } value, event
            }
        };

        /********民族nationality********/
        //民族Value const nationality = ref('汉族');
        const nationality_date = reactive({
            //是否显示
            is_show: false,
            //证件类型list
            List: [
                { text: '汉族', value: '01', pk: '@@@@Z710000000005L2S' },
                { text: '蒙古族', value: '02', pk: '@@@@Z710000000005L2T' },
                { text: '回族', value: '03', pk: '@@@@Z710000000005L2U' },
                { text: '藏族', value: '04', pk: '@@@@Z710000000005L2V' },
                { text: '维吾尔族', value: '05', pk: '@@@@Z710000000005L2W' },
                { text: '苗族', value: '06', pk: '@@@@Z710000000005L2X' },
                { text: '壮族', value: '08', pk: '@@@@Z710000000005L2SZ' },
                { text: '朝鲜族', value: '10', pk: '@@@@Z710000000005L31' }
            ]
        });
        //民族选择
        const nationalityConfirm = ({ selectedValue, selectedOptions }) => {
            console.log(selectedValue);
            console.log(selectedOptions);
            //psndoc.nationality = selectedOptions.map((option) => option.pk);//selectedValue;
            selectedOptions.map(function (option) {
                psndoc.nationality = option.pk;
            });
            psndoc.nationality_name = selectedOptions.map((option) => option.text);
        }

        /********血型bloodtype********/
        const bloodtypeConfirm = ({ selectedValue, selectedOptions }) => {
            console.log(selectedValue);
            console.log(selectedOptions);
            selectedOptions.map(function (option) {
                psndoc.bloodtype = option.value;
            });
            psndoc.bloodtype_name = selectedOptions.map((option) => option.text);
            console.log(psndoc);
        }
        /********血型类型********/
        const bloodtype_date = reactive({
            //是否显示
            is_show: false,
            //默认选中
            //selectedValue:'CN01',
            //证件类型list
            List: [
                { text: 'O', value: '1' },
                { text: 'A', value: '2' },
                { text: 'B', value: '3' },
                { text: 'AB', value: '4' },
                { text: '其他', value: '5' }
            ]
        });

        /************政治面貌************/
        const polityConfirm = ({ selectedValue, selectedOptions }) => {
            console.log(selectedValue);
            console.log(selectedOptions);
            //psndoc.polity= selectedOptions.map((option) => option.pk);//selectedValue;
            selectedOptions.map(function (option) {
                psndoc.polity = option.pk;
            });
            psndoc.polity_name = selectedOptions.map((option) => option.text);
        }
        /********政治面貌polity********/
        const polity_date = reactive({
            //是否显示
            is_show: false,
            //证件类型list
            List: [
                { text: '党员', value: '01', pk: '@@@@Z710000000005L8E' },
                { text: '预备党员', value: '02', pk: '@@@@Z710000000005L8F' },
                { text: '团员', value: '03', pk: '@@@@Z710000000005L8G' },
                { text: '群众', value: '13', pk: '@@@@Z710000000005L8Q' },
            ]
        });
        /************计算机水平************/
        const computerLevelConfirm = ({ selectedValue, selectedOptions }) => {
            selectedOptions.map(function (option) {
                psndoc.computerlevel = option.value;
            });
        }
        /*计算机水平*/

        // 计算机等级考试三级；计算机等级考试二级；计算机等级考试一级；熟练；一般；不熟悉
        const computerlevelSelct = reactive({
            //是否显示
            is_show: false,
            //计算机水平list
            List: [
                { text: '计算机等级考试三级', value: '计算机等级考试三级' },
                { text: '计算机等级考试二级', value: '计算机等级考试二级' },
                { text: '计算机等级考试一级', value: '计算机等级考试一级' },
                { text: '熟练', value: '熟练' },
                { text: '一般', value: '一般' },
                { text: '不熟悉', value: '不熟悉' },
            ]
        });

        /***************婚姻状况****************/
        const maritalConfirm = ({ selectedValue, selectedOptions }) => {
            console.log(selectedValue);
            console.log(selectedOptions);
            //psndoc.polity= selectedOptions.map((option) => option.pk);//selectedValue;
            selectedOptions.map(function (option) {
                psndoc.marital = option.pk;
            });
            psndoc.marital_name = selectedOptions.map((option) => option.text);
        }
        /***************婚姻状况****************/
        const marital_date = reactive({
            //是否显示
            is_show: false,
            //证件类型list
            List: [
                { text: '未婚', value: '10', pk: '@@@@Z710000000005L1Y' },
                //{ text: '已婚', value: '20',pk:'@@@@Z710000000005L1Z' },
                { text: '已婚无子女', value: '21', pk: '@@@@Z710000000005L20' },
                { text: '已婚一子', value: '22', pk: '@@@@Z710000000005L21' },
                { text: '已婚一女', value: '23', pk: '@@@@Z710000000005L22' },
                { text: '已婚一子一女', value: '24', pk: '1001A11000000048HDI0' },
                { text: '已婚两子', value: '25', pk: '1001A11000000048HDJZ' },
                { text: '已婚两女', value: '26', pk: '1001A11000000048HDKP' },
                { text: '已婚三子', value: '27', pk: '1001A11000000048HEV8' },
                { text: '已婚三女', value: '28', pk: '1001A11000000048HF1E' },
                { text: '已婚两子一女', value: '29', pk: '1001A11000000048HF1V' },
                { text: '已婚两女一子', value: '291', pk: '1001A11000000048HG0T' },
                { text: '丧偶', value: '30', pk: '@@@@Z710000000005L23' },
                { text: '离异', value: '40', pk: '@@@@Z710000000005L24' },
                { text: '未说明的婚姻状况', value: '90', pk: '@@@@Z710000000005L25' },
            ]
        });
        /********外语语种  glbdef10********/
        const glbdef10Confirm = ({ selectedValue, selectedOptions }) => {
            console.log(selectedValue);
            console.log(selectedOptions);
            //psndoc.glbdef10= selectedOptions.map((option) => option.pk);//selectedValue;
            selectedOptions.map(function (option) {
                psndoc.glbdef10 = option.pk;
            });
            psndoc.glbdef10_name = selectedOptions.map((option) => option.text);
        }

        const glbdef10_date = reactive({
            //是否显示
            is_show: false,
            //证件类型list
            List: [
                { text: '英语', value: '01', pk: '1001A11000000048FK00' },
                { text: '俄语', value: '02', pk: '1001A11000000048FK01' },
                { text: '日语', value: '03', pk: '1001A11000000048FK02' },
                { text: '韩语', value: '04', pk: '1001A11000000048FK03' },
                { text: '德语', value: '05', pk: '1001A11000000048FK04' },
                { text: '其他', value: '06', pk: '1001A11000000048FK05' }
            ]
        });

        /********外语登记  glbdef11********/
        const glbdef11_date = reactive({
            //是否显示
            is_show: false,
            //证件类型list
            List: [
                { text: '一级', value: '01', pk: '1001A11000000048FKS1' },
                { text: '二级', value: '02', pk: '1001A11000000048FKS2' },
                { text: '三级', value: '03', pk: '1001A11000000048FKS3' },
                { text: '四级', value: '04', pk: '1001A11000000048FKS4' },
                { text: '五级', value: '05', pk: '1001A11000000048FKS5' },
                { text: '六级', value: '06', pk: '1001A11000000048FKS6' },
                { text: '七级', value: '07', pk: '1001A11000000048FKS7' },
                { text: '八级', value: '08', pk: '1001A11000000048FKS8' }
            ]
        });

        const glbdef11Confirm = ({ selectedValue, selectedOptions }) => {
            console.log(selectedValue);
            console.log(selectedOptions);
            //psndoc.glbdef11= selectedOptions.map((option) => option.pk);//selectedValue;
            selectedOptions.map(function (option) {
                psndoc.glbdef11 = option.pk;
            });
            psndoc.glbdef11_name = selectedOptions.map((option) => option.text);
        }
        //健康状况 1:健康，2:良好const health=ref('1');
        //婚姻状况 1:未婚，2:已婚const marital=ref('1');


        /********应聘组织********/
        const pk_reg_org_date = reactive({
            //是否显示
            is_show: false,
            //证件类型list
            List: [
                { text: '山东仁丰特种材料股份有限公司', value: '1', pk: '0001A110000000002UST' },
                // { text: '淄博弘瑞再生资源有限公司', value: '101',pk:'0001A110000000002UUZ' },
                // { text: '淄博惠润热力有限公司', value: '102',pk:'0001A110000000002UWH' },
                // { text: '淄博智瑞纸业有限公司', value: '103' ,pk:'0001A110000000002UY1'},
                // { text: '淄博金丰新材料有限公司', value: '104' ,pk:'0001A110000000002UZG'},
                // { text: '山东仁丰特种材料股份有限公司上海分公司', value: '105' ,pk:'0001A110000000002V12'},
                // { text: '淄博惠润热力有限公司', value: '106' ,pk:'0001A1100000000EY7GR'},
            ]
        });
        const pk_reg_orgConfirm = ({ selectedValue, selectedOptions }) => {
            console.log(selectedValue);
            console.log(selectedOptions);
            //psndoc.job.pk_reg_org= selectedOptions.map((option) => option.pk);//selectedValue;
            selectedOptions.map(function (option) {
                psndoc.pk_reg_org = option.pk;
            });
            psndoc.job.pk_reg_org_name = selectedOptions.map((option) => option.text);
        }

        /********应聘职位信息********/
        //SELECT  r.pk_publishjob,rj.code,rj.name   FROM  rm_publish r,rm_job rj WHERE r.pk_job=rj.pk_job
        const pk_reg_job_date = reactive({
            //是否显示
            is_show: false,
            //证件类型list
            List: [
                { pk: '0', value: '0', text: '操作工' },
                { pk: '1', value: '1', text: '仓管多能工' },
                { pk: '2', value: '2', text: '厨师' },
                { pk: '1001A11000000052YEKG', value: '000107', text: '叉车司机' },
                { pk: '1001A11000000052YEIJ', value: '000101', text: '质检员' },
                { pk: '1001A11000000052YEIS', value: '000103', text: '电工' },
                { pk: '1001A11000000052YEIM', value: '000102', text: '仪表工' },
                { pk: '1001A11000000052YH8N', value: '000207', text: '企管专员' },
                { pk: '3', value: '3', text: '采购专员' },
                { pk: '1001A11000000052YHEV', value: '000212', text: '业务经理' },
                { pk: '1001A11000000052YHK8', value: '000301', text: '液压工程师' },
                { pk: '1001A11000000052YHM4', value: '000303', text: '机械工程师' },
                { pk: '1001A11000000052YHTX', value: '000305', text: '电气工程师' },
                { pk: '4', value: '4', text: '仪表工程师' },
                { pk: '1001A11000000052YHV6', value: '000307', text: '品管工程师' },
                { pk: '5', value: '5', text: '开发工程师' },
                { pk: '6', value: '00401', text: '办公室文员' },
                { pk: '7', value: '00402', text: '班车司机' },
                { pk: '8', value: '00403', text: '装载机司机' },
                { pk: '9', value: '00404', text: '服务员' },
                { pk: '10', value: '00406', text: '财务总监' },
                { pk: '11', value: '00407', text: '维修工' },
                { pk: '12', value: '00408', text: '审计岗' },
                { pk: '13', value: '00409', text: '证券岗' },
                { pk: '14', value: '00410', text: '营销内勤' },
                { pk: '15', value: '00411', text: '生产管理管培生' },
                { pk: '16', value: '00412', text: '商务司机' },
                { pk: '17', value: '00413', text: '外贸跟单专员' },
                { pk: '18', value: '00414', text: '环保项目管理专员' },
                { pk: '19', value: '00415', text: '基建工程师' },
                { pk: '20', value: '00416', text: '技改工程师' },
                { pk: '21', value: '00417', text: '电厂管培生' },
                { pk: '22', value: '00418', text: '电仪管培生' },
                { pk: '23', value: '00419', text: '环保管培生' },
                { pk: '24', value: '00420', text: '营销管培生' },
                { pk: '25', value: '00421', text: '财务管培生' },
                { pk: '1001A11000000052YHVJ', value: '00405', text: '其他' }
                // { pk: '1001A11000000052YEK1', value: '000104', text: '生产管培生' },
                // { pk: '1001A11000000052YEK4', value: '000105', text: '维修工' },
                // { pk: '1001A11000000052YEK7', value: '000106', text: '操作工' },
                // { pk: '1001A11000000052YEKV', value: '000108', text: '装载司机' },
                // { pk: '1001A11000000052YELL', value: '000109', text: '保管员' },
                // { pk: '1001A11000000052YELQ', value: '000110', text: '地磅员' },
                // { pk: '1001A11000000052YELU', value: '000111', text: '司炉工' },
                // { pk: '1001A11000000052YELX', value: '000112', text: '汽轮机普工' },
                // { pk: '1001A11000000052YEPJ', value: '000201', text: '会计' },
                // { pk: '1001A11000000052YEPM', value: '000202', text: '统计员' },
                // { pk: '1001A11000000052YEPQ', value: '000203', text: '出纳' },
                // { pk: '1001A11000000052YH8E', value: '000204', text: '行政文员' },
                // { pk: '1001A11000000052YH8H', value: '000205', text: '人事专员' },
                // { pk: '1001A11000000052YH8K', value: '000206', text: '营销内勤' },
                // { pk: '1001A11000000052YHEJ', value: '000208', text: '审计专员' },
                // { pk: '1001A11000000052YHEM', value: '000209', text: '法务专员' },
                // { pk: '1001A11000000052YHEP', value: '000210', text: '物流经理' },
                // { pk: '1001A11000000052YHES', value: '000211', text: '采购经理' },
                // { pk: '1001A11000000052YHEY', value: '000213', text: '行政管培生' },
                // { pk: '1001A11000000052YHKB', value: '000302', text: '安全工程师' },
                // { pk: '1001A11000000052YHRW', value: '000304', text: '工艺工程师' },
                // { pk: '1001A11000000052YHUB', value: '000306', text: '研发工程师' },
                // { pk: '1001A11000000052YHVD', value: '000308', text: '环保工程师' },
                // { pk: '1001A11000000052YHVG', value: '000309', text: '专业技术人员' },
            ]
        });
        const pk_reg_jobConfirm = ({ selectedValue, selectedOptions }) => {
            console.log(selectedValue);
            console.log(selectedOptions);
            selectedOptions.map(function (option) {
                psndoc.job.pk_reg_job = option.text;
            });
            psndoc.job.pk_reg_job_name = selectedOptions.map((option) => option.text);
            console.log(psndoc.job);
        }

        /******************学历信息*******************/
        let edu_begindate_sel_index = ref(0);
        //入学日期
        const begindate_data = reactive({
            is_show: false,
            minDate: new Date(1990, 0, 1),
            maxDate: new Date(2030, 0, 1),
        });
        //入学日期Valueconst begindate=ref();
        //入学日期选择
        const begindataConfirm = ({ selectedValue, selectedOptions }) => {
            console.log(selectedValue);
            console.log(selectedOptions);
            psndoc.edus[edu_begindate_sel_index.value].begindate = selectedOptions.map((option) => option.text).join('-');
        }

        //毕业日期
        let edu_enddate_sel_index = ref(0);
        const enddate_data = reactive({
            is_show: false,
            minDate: new Date(1990, 0, 1),
            maxDate: new Date(2030, 0, 1),
        });
        //入学日期Valueconst enddate=ref();
        //毕业日期选择
        const enddateConfirm = ({ selectedValue, selectedOptions }) => {
            console.log(selectedValue);
            console.log(selectedOptions);
            psndoc.edus[edu_enddate_sel_index.value].enddate = selectedOptions.map((option) => option.text).join('-');
        }
        /********学历education********/
        //学历Valueconst education = ref('');
        let edu_education_sel_index = ref(0);
        const education_data = reactive({
            //是否显示
            is_show: false,
            //学历list
            List: [
                //{ text: '一本', value: '01',pk:'1001IN1000000000L5HG' },
                //{ text: '二本', value: '02',pk:'1001IN1000000000L5LR' },
                //{ text: '三本', value: '03' ,pk:'1001IN1000000000L5O9'},
                { text: '博士', value: '20', pk: '@@@@Z710000000005L5K' },
                { text: '硕士', value: '21', pk: '@@@@Z710000000005L5N' },
                { text: '专升本', value: '04', pk: '1001IN1000000000L5TS' },
                { text: '大学本科', value: '25', pk: '@@@@Z710000000005L5U' },
                { text: '大专', value: '30', pk: '@@@@Z710000000005L5Y' },
                { text: '中专', value: '41', pk: '@@@@Z710000000005L62' },
                { text: '职高', value: '44', pk: '@@@@Z710000000005L65' },
                { text: '技校', value: '47', pk: '@@@@Z710000000005L68' },
                { text: '高中', value: '61', pk: '@@@@Z710000000005L6C' },
                { text: '初中', value: '71', pk: '@@@@Z710000000005L6G' },
                { text: '小学', value: '81', pk: '@@@@Z710000000005L6J' },
                { text: '其他', value: '90', pk: '@@@@Z710000000005L6L' },
            ]
        });
        const education_data2 = reactive({
            //是否显示
            is_show: false,
            //学历list
            List: [
                //{ text: '一本', value: '01',pk:'1001IN1000000000L5HG' },
                //{ text: '二本', value: '02',pk:'1001IN1000000000L5LR' },
                //{ text: '三本', value: '03' ,pk:'1001IN1000000000L5O9'},
                { text: '博士', value: '20', pk: '@@@@Z710000000005L5K' },
                { text: '硕士', value: '21', pk: '@@@@Z710000000005L5N' },
                { text: '专升本', value: '04', pk: '1001IN1000000000L5TS' },
                { text: '大学本科', value: '25', pk: '@@@@Z710000000005L5U' },
                { text: '大专', value: '30', pk: '@@@@Z710000000005L5Y' },
                { text: '中专', value: '41', pk: '@@@@Z710000000005L62' },
                { text: '职高', value: '44', pk: '@@@@Z710000000005L65' },
                { text: '技校', value: '47', pk: '@@@@Z710000000005L68' },
                { text: '高中', value: '61', pk: '@@@@Z710000000005L6C' },
                { text: '初中', value: '71', pk: '@@@@Z710000000005L6G' },
                { text: '小学', value: '81', pk: '@@@@Z710000000005L6J' },
                { text: '其他', value: '90', pk: '@@@@Z710000000005L6L' },
            ]
        });

        //psndoc.edu最高学历选择
        const psnEduConfirm = ({ selectedValue, selectedOptions }) => {
            selectedOptions.map(function (option) {
                psndoc.edu = option.pk
                psndoc.edu_name = option.text
            }
            );
            console.log(psndoc);
        }

        //psnd.euds教育信息-学历选择
        const educationConfirm = ({ selectedValue, selectedOptions }) => {
            selectedOptions.map(function (option) {
                psndoc.edus[edu_education_sel_index.value].education = option.pk
            }
            );
            psndoc.edus[edu_education_sel_index.value].education_name = selectedOptions.map((option) => option.text);
        }
        //学习方式选择
        let studymode_sel_index = ref(0);
        const studymode_data = reactive({
            //是否显示
            is_show: false,
            //学习方式list
            List: [
                { text: '全日制', value: '1', pk: '1001Z710000000016XIZ' },
                { text: '非全日制', value: '2', pk: '1001Z710000000016XJ1' },
                { text: '在职研究生', value: '201', pk: '1001Z710000000016XJ2' },
                { text: '电大', value: '202', pk: '1001Z710000000016XJ3' },
                { text: '夜大', value: '203', pk: '1001Z710000000016XJ4' },
                { text: '函授', value: '204', pk: '1001Z710000000016XJ5' },
                { text: '党校', value: '205', pk: '1001Z710000000016XJ6' },
                { text: '自考', value: '206', pk: '1001Z710000000016XJ7' },
                { text: '成人教育', value: '207', pk: '1001Z710000000016XJJ' },
                { text: '网络教育', value: '208', pk: '1001Z710000000016XJK' },
                { text: '其他', value: '213', pk: '1001Z710000000016XJP' }
            ]
        });

        //学习方式选择
        const studymodeConfirm = ({ selectedValue, selectedOptions }) => {
            console.log(selectedValue);
            console.log(selectedOptions);
            //psndoc.edus[edu_education_sel_index.value].education= 
            selectedOptions.map(function (option) {
                psndoc.edus[studymode_sel_index.value].studymode = option.pk
            }
            );//selectedValue;
            psndoc.edus[studymode_sel_index.value].studymode_name = selectedOptions.map((option) => option.text);
        }
        //是否最高学历 
        //如果多个学历 则进行互斥操作
        const educationChange = (index) => {
            console.log(index);
            if (psndoc.edus.length > 1) {
                let edu = psndoc.edus[index];
                if (edu.lastflag) {
                    for (let i = 0; i < psndoc.edus.length; i++) {
                        if (i != index) {
                            psndoc.edus[i].lastflag = false;
                        }
                    }
                }
            }
        }

        /********************工作记录***********************/
        //开始日期
        const work_begindate_data = reactive({
            is_show: false,
            minDate: new Date(1990, 0, 1),
            maxDate: new Date(2030, 0, 1),
        });
        //开始日期Valueconst work_begindate=ref();
        let work_begindate_sel_index = ref(0);
        //开始日期选择
        const work_begindateConfirm = ({ selectedValue, selectedOptions }) => {
            console.log(selectedValue);
            console.log(selectedOptions);
            psndoc.works[work_begindate_sel_index.value].begindate = selectedOptions.map((option) => option.text).join('-');
        }
        //结束日期
        const work_enddate_data = reactive({
            is_show: false,
            minDate: new Date(1990, 0, 1),
            maxDate: new Date(2030, 0, 1),
        });
        //结束日期Valueconstwork_enddate=ref();
        let work_enddate_sel_index = ref(0);
        //结束日期选择
        const work_enddateConfirm = ({ selectedValue, selectedOptions }) => {
            console.log(selectedValue);
            console.log(selectedOptions);
            psndoc.works[work_enddate_sel_index.value].enddate = selectedOptions.map((option) => option.text).join('-');
        }


        //生日
        const mem_birthday_data = reactive({
            is_show: false,
            minDate: new Date(1950, 0, 1),
            maxDate: new Date(2030, 0, 1),
        });
        //生日
        let mem_birthday_sel_index = ref(0);
        //生日选择
        const mem_birthdayConfirm = ({ selectedValue, selectedOptions }) => {
            console.log(selectedValue);
            console.log(selectedOptions);
            psndoc.persons[mem_birthday_sel_index.value].mem_birthday = selectedOptions.map((option) => option.text).join('-');
        }
        /********************家庭记录*****
        * select b.pk_defdoc,b.code,b.name from  bd_defdoc b where b.pk_defdoclist='1001Z710000000016XLD';
        ******************/
        let psn_relation_sel_index = ref(0);
        const psn_data = reactive({
            is_show: false,
            List: [
                { text: '配偶', value: '1', pk: '1001Z710000000006O03' },
                { text: '子', value: '2', pk: '1001Z710000000006O04' },
                { text: '女', value: '3', pk: '1001Z710000000006O05' },
                { text: '祖父(母) 外祖父(母)', value: '6', pk: '1001Z710000000006O08' },
                { text: '父母', value: '5', pk: '1001Z710000000006O07' },
                { text: '兄弟姐妹', value: '7', pk: '1001Z710000000006O09' },
                { text: '对象父母', value: '10', pk: '1001A1100000004YWQE8' },
                { text: '其他', value: '9', pk: '1001Z710000000006O0A' },
            ]
        });
        //家庭关系选择
        const psnConfirm = ({ selectedValue, selectedOptions }) => {
            console.log(selectedValue);
            console.log(selectedOptions);
            //psndoc.persons[psn_relation_sel_index.value].mem_relation= selectedOptions.map((option) => option.pk);//selectedValue;
            selectedOptions.map(function (option) {
                psndoc.persons[psn_relation_sel_index.value].mem_relation = option.pk
            });
            psndoc.persons[psn_relation_sel_index.value].mem_relation_name = selectedOptions.map((option) => option.text);
        }

        //上传图片地址   
        const uploadUrl = baseUrl + '/rmpsndoc/rmPsndoc/uploadFile';
        //上传的参数
        const fileformData = reactive({
            // pk_psndoc: psndoc.pk_psndoc
            filePath: []
        });
        const beforeDelete = (file, fileList) => {
            console.log("beforeDelete", file, fileList);
            // 使用 filter 方法创建一个新的数组，排除要删除的文件
            // const updatedFileList = fileList.filter(item => item.uid !== file.uid);
            // 更新 defaultFileList
            const tempFileList = defaultFileList.filter(item => item.uid !== file.uid);
            defaultFileList.splice(0, defaultFileList.length, ...tempFileList);
            console.log("afterDelete", defaultFileList);
            return true;
        }
        const beforeUpload = (xhr, options) => {
            console.log("beforeUpload", xhr, options);
            let now = new Date().getTime();
            let data = {
                'X-TIMESTAMP': now
            }
            xhr.setRequestHeader("X-TIMESTAMP", now);
            xhr.setRequestHeader("X-SIGN", signMd5Utils.getSign(uploadUrl, data));
            const formData = new FormData();
            formData.append('file', options.sourceFile); // 确保这里的 key 是 'file'
            xhr.send(formData);
        }
        //上传成功
        const upSuccess = ({ responseText, option, fileItem }) => {
            console.log("上传成功");
            console.log(responseText, option, fileItem);
            if (responseText != '') {
                let data = JSON.parse(responseText);
                if (data.success) {
                    defaultFileList.push({
                        // url: fileItem.url,
                        filePath: data.result,
                        name: fileItem.name,
                        status: 'success',
                        message: '上传成功',
                        percent: 100,
                        uid: fileItem.uid
                    })
                } else {
                    Notify.danger('附件上传异常:' + data.MESSAGE);
                }
            } else {
                Notify.danger('附件上传异常!');
            }
            console.log(option);
            console.log(fileItem);
            console.log(defaultFileList);
        }
        //上传失败
        const upError = ({ responseText, option, fileItem }) => {
            console.log("上传失败");
            console.log(responseText.SUCCESS);
            console.log(responseText.MESSAGE);
            console.log(option);
            console.log(fileItem);
        }
        const onOversize = (files) => {
            Toast.fail('文件大小不能超过 5MB!');
        }
        console.log(qs);
        /*提交按钮 是否可用*/
        const submit_disabled = ref(false);
        const submit = () => {
            console.log('===============', psndoc);
            const p1 = new Promise(function (resolve, reject) {
                /* 应聘信息*/
                 job_ruleForm.value.validate().then(({ valid, errors }) => {
                    if (valid) {
                        resolve(valid);
                        //重置错误消息
                        job_ruleForm.value.reset();
                        //console.log('success', this.psndoc);
                    } else {
                        console.log('应聘信息 submit 错误', errors);
                        reject('请填写应聘信息中的必填项!');
                    }
                }); 
                /*基础信息校验*/
                base_ruleForm.value.validate().then(({ valid, errors }) => {
                    if (valid) {
                        resolve(valid);
                        //重置错误消息
                        base_ruleForm.value.reset();
                        //console.log('success', this.psndoc);
                    } else {
                        console.log('基础信息 submit 错误', errors);
                        reject('请填写基本信息中的必填项!');
                    }
                });

            }).then(function (value) {
                console.log(value);
                /*学历信息*/
                if (value) {
                    let error = '教育信息：';
                    for (let i = 0; i < psndoc.edus.length; i++) {
                        let edu = psndoc.edus[i];
                        //学校
                        if (edu.school === '' || edu.school.trim().length == 0) {
                            error = error.concat('学校信息 ');
                        }
                        //入学日期
                        if (edu.begindate === '' || edu.begindate.trim().length == 0) {
                            error = error.concat('入学日期 ');
                        }
                        //毕业日期
                        if (edu.enddate === '' || edu.enddate.trim().length == 0) {
                            error = error.concat('毕业日期');
                        } else if (new Date(edu.enddate) <= new Date(edu.begindate)) {
                            error = error.concat(' 毕业日期不能早于入学日期 ');
                            break;
                        }
                        //专业
                        if (edu.major === '' || edu.major.trim().length == 0) {
                            error = error.concat('专业 ');
                        }
                        //学习方式
                        if (edu.studymode === '' || edu.studymode.trim().length == 0) {
                            error = error.concat('学习方式 ');
                        }
                        //学历
                        if (edu.education === '' || edu.education.trim().length == 0) {
                            error = error.concat('学历 ');
                        }

                    }
                    console.log(error.indexOf('不能早于'));

                    if (error.length > 5) {
                        if (error.indexOf('不能早于') == -1) {
                            error.concat(' 非空!')
                        }
                        Notify.danger(error);
                        return;
                    }

                    error = '工作信息：';
                    for (let i = 0; i < psndoc.works.length; i++) {
                        let work = psndoc.works[i];
                        console.log(work);
                        //入职日期
                        if (work.begindate === '' || work.begindate.trim().length == 0) {
                            error = error.concat(' 入职日期 ');
                        }
                        //离职日期
                        if (work.enddate === '' || work.enddate.trim().length == 0) {
                            error = error.concat('离职日期 ');
                        } else if (new Date(work.enddate) <= new Date(work.begindate)) {
                            error = error.concat(' 离职日期不能早于入职日期 ');
                            break;
                        }
                        //工作单位
                        if (work.workcorp === '' || work.workcorp.trim().length == 0) {
                            error = error.concat('工作单位 ');
                        }
                        //工作职务
                        if (work.workjob === '' || work.workjob.trim().length == 0) {
                            error = error.concat('工作职务 ');
                        }
                        //证明人
                        if (work.certifier === '' || work.certifier.trim().length == 0) {
                            error = error.concat('直接上级 ');
                        }
                        //证明人电话
                        if (work.worcertiphonekcorp === '' || work.certiphone.trim().length == 0) {
                            error = error.concat('直接上级联系方式 ');
                        }
                        //离职原因
                        if (work.dismismatter === '' || work.dismismatter.trim().length == 0) {
                            error = error.concat('离职原因 ');
                        }
                    }
                    if (error.length > 5) {
                        if (error.indexOf('不能早于') == -1) {
                            error.concat(' 非空!')
                        }
                        Notify.danger(error);
                        return;
                    }

                    error = '家庭信息：';
                    for (let i = 0; i < psndoc.persons.length; i++) {
                        let psn = psndoc.persons[i];
                        console.log(psn);
                        //姓名
                        if (psn.mem_name === '' || psn.mem_name.trim().length == 0) {
                            //Notify.danger('家庭信息:'+(i+1)+' 行,成员姓名非空!');
                            error = error.concat('姓名 ');
                        }
                        //工作单位
                        if (psn.mem_corp === '' || psn.mem_corp.trim().length == 0) {
                            error = error.concat('工作单位及职务 ');
                        }
                        //与本人关系2022-7-26
                        if (psn.mem_relation === '' || psn.mem_relation.trim().length == 0) {
                            //Notify.danger('家庭信息:'+(i+1)+' 行,成员姓名非空!');
                            error = error.concat('家庭关系 ');
                        }
                        //成员姓名
                        if (psn.mem_name === '' || psn.mem_name.trim().length == 0) {
                            //Notify.danger('家庭信息:'+(i+1)+' 行,成员姓名非空!');
                            error = error.concat('成员姓名 ');
                        }
                        // 成员年龄
                        // if (psn.glbdef3 === '') {
                        //     //Notify.danger('家庭信息:'+(i+1)+' 行,成员姓名非空!');
                        //     error = error.concat('成员年龄 ');
                        // }
                        //生日
                        if (psn.mem_birthday === '' || psn.mem_birthday.trim().length == 0) {
                            error = error.concat('生日');
                        }
                    }
                    if (error.length > 5) {
                        Notify.danger(error.concat(' 非空!'));
                    } else {
                        //*************************提交数据************************
                        //显示提交加载
                        Toast.loading('信息提交中...', {
                            duration: 0,
                            cover: true
                        });
                        console.log(psndoc);
                        let url = baseUrl + '/rmpsndoc/rmPsndoc/addFromMobile';
                        let jobArray = [psndoc.job];
                        // 创建一个新的对象来包含所有数据，包括转换后的 job 数组
                        let dataToSend = {
                            ...psndoc,
                            job: jobArray,
                            fileList: defaultFileList
                            // ... 其他数据
                        };
                        console.log(dataToSend);
                        // 创建一个新的对象来包含所有数据，包括转换后的 job 数组
                        let sign = signMd5Utils.getSign(url, dataToSend);
                        let now = new Date().getTime();
                        api.post(url, dataToSend, {
                            headers: {
                                'X-Sign': sign,
                                'X-TIMESTAMP': now
                            }
                        }).then(res => {
                            console.log(res);
                            //关闭
                            Toast.hide();
                            //显示成功
                            if (res.data.success) {
                                localStorage.removeItem('psndoc');
                                localStorage.setItem('lasttime', new Date().getTime());
                                //显示遮罩层 防止重复提交
                                show_overlay.value = true;
                                //登记成功后 提示
                                Toast.success('登记成功', {
                                    duration: 0,
                                    cover: true
                                });
                            } else {
                                Toast.fail(res.data.message);
                            }
                        });
                    }
                }
            }, function (err) {
                Notify.danger(err);
            }).catch((e) => {
                //Notify.danger(e);
                console.log(e);
            });
            console.log(p1);
            /*****************调用接口同步********************/
        }
        /*暂存功能*/
        const saveTemp = () => {
            localStorage.setItem('psndoc', JSON.stringify(psndoc));
            Notify.success('暂存成功');

        }
        /*离开页面提醒*/
        const handleBeforeUnload = (event) => {
            console.log(event)
            // 取消默认行为
            event.preventDefault();
            // Chrome 需要设置 returnValue
            event.returnValue = '当前信息未保存，是否确定离开此页面？';
        };
        onMounted(() => {
            // 添加事件监听器
            window.addEventListener('beforeunload', handleBeforeUnload);
            console.log('组件已挂载到DOM！');
            // 在这里可以执行其他需要DOM的操作
            if (localStorage.getItem('psndoc')) {
                const psndocFromLocalStorage = JSON.parse(localStorage.getItem('psndoc'));
                Object.assign(psndoc, psndocFromLocalStorage);
            }
            if (localStorage.getItem('lasttime')) {
                let lasttime = localStorage.getItem('lasttime');
                if (new Date().getTime() - lasttime < 1296000000) {
                    show_overlay.value = true;
                    Toast.success('您已提交成功，请勿重复提交！', {
                        duration: 0,
                        cover: true
                    });
                }
            }
        });
        onUnmounted(() => {
            // 移除事件监听器
            window.removeEventListener('beforeunload', handleBeforeUnload);
        });
        return {
            base_ruleForm, job_ruleForm, edu_ruleForm, work_ruleForm, psn_ruleForm, validate,
            psndoc, generatePinyin,
            src_fromdata, srcfromConfirm,
            birthdate_data, birthdateConfirm,
            idtype_date, idtypeConfirm, formatter,
            bloodtype_date, bloodtypeConfirm,//血型
            polity_date, polityConfirm,
            marital_date, maritalConfirm,//婚姻
            glbdef10_date, glbdef10Confirm,//外语语种
            glbdef11_date, glbdef11Confirm,//外语登记
            pk_reg_org_date, pk_reg_orgConfirm,//应聘组织
            pk_reg_job_date, pk_reg_jobConfirm,//应聘职位
            edu_begindate_sel_index, edu_enddate_sel_index, edu_education_sel_index,
            studymode_sel_index, studymode_data, studymodeConfirm,//学习方式
            nationality_date, nationalityConfirm,
            begindate_data, begindataConfirm,
            enddate_data, enddateConfirm,
            education_data, education_data2, educationConfirm, psnEduConfirm, educationChange,
            work_begindate_data, work_begindate_sel_index, work_begindateConfirm,
            work_enddate_data, work_enddate_sel_index, work_enddateConfirm,
            psn_relation_sel_index, psn_data, psnConfirm,
            uploadUrl, fileformData, uploadHeaders, upSuccess, upError, beforeUpload, beforeDelete, onOversize, saveTemp,
            mem_birthday_data, mem_birthday_sel_index, mem_birthdayConfirm,
            show_overlay, submit_disabled, submit, computerlevelSelct, computerLevelConfirm
        };
    },
    methods: {
        //添加学历
        addEdu() {
            this.psndoc.edus.push({
                "school": "", //学校
                "begindate": "", //入学日期
                "enddate": "", //毕业日期
                "major": "",//"专业 
                "studymode": "",//学习方式  1001Z710000000016XIZ
                "studymode_name": "",//学习方式  全日制
                "education": "",//学历 
                "lastflag": "", //是否最高学历
                "degree": ""//学位
            });
        },
        //删除学历
        delEdu(index) {
            if (index > 0) {
                this.psndoc.edus.splice(index, 1);
            }
        },
        //添加工作信息
        addWork() {
            this.psndoc.works.push({
                "begindate": "", //入学日期
                "enddate": "",//毕业日期 
                "workcorp": "",//工作单位 
                "workjob": "",//担任职务 
                "workduty": "",//主要职责 
                "certifier": "",//证明人 
                "certiphone": "",//证明人电话 
                "dismismatter": ""//证明人电话
            });
        },
        //删除学历
        delWork(index) {
            if (index > 0) {
                this.psndoc.works.splice(index, 1);
            }
        },
        //添加人员
        addPsn() {
            this.psndoc.persons.push({
                "mem_name": "", //家庭成员姓名
                "mem_relation": "",//与本人关系 
                "workcorp": "",//工作单位 
                "mem_birthday": "",//出生日期 
                "mem_corp": "",//工作单位 
                "mem_job": "",//职务 
                "vrelaphone": "",//联系电话
                "glbdef1": false,//是否紧急联系人
                "glbdef3": ""//年龄
            });
        },
        //删除学历
        delPsn(index) {
            if (index > 0) {
                this.psndoc.persons.splice(index, 1);
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2 {
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 14px;
    color: #909ca4;
    padding: 0 10px;
    font-weight: 400;
}

.width100 {
    width: 100%;
}

.backtop-demo .item {
    height: 46px;
    background: #efefef;
    line-height: 46px;
    padding: 0px 20px;
    margin-bottom: 20px;
}
</style>